import React, { useCallback, useEffect, useRef, useState } from "react";
import personaServicio from "../../services/persona/personaServicio";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import AreaService from "../../services/administracion/Area/AreaService";
interface IcomboBoxSearch {
  search: string;
}

export const useComboAreas = () => {
  const [dataComboArea, setDataComboArea] = useState<IComboBoxOption[]>([]);
  const [filter, setFilter] = useState<IcomboBoxSearch>({
    search: "",
  });

  const comboBoxAreaRef = useRef<IComboBox>(null);
  const _openOptionComboArea = useCallback(
    () => comboBoxAreaRef.current?.focus(true),
    []
  );
  const _onKeyUpSearchArea = (event: React.KeyboardEvent<IComboBox>) => {
    if (event.code === "Escape") {
      comboBoxAreaRef.current?.focus(false);
    } else {
      _openOptionComboArea();
      let { value } = event?.target as HTMLInputElement;
      setFilter({ search: value });
    }
  };
  const onClickOpen = () => {
    comboBoxAreaRef.current?.focus(true);
  };

  const getComboArea = () => {
    AreaService.postComboArea(filter).then((res) => {
      if (res.status === 200) {
        setDataComboArea(res.data);
      }
    });
  };

  useEffect(() => {
    getComboArea();
  }, [filter.search]);

  return {
    onClickOpen,
    _onKeyUpSearchArea,
    dataComboArea,
    comboBoxAreaRef,
  };
};
